import styled from '@emotion/styled'
import { CSSTransition } from 'react-transition-group'
import { Flex } from 'rebass'

import Thumb, { THUMB_SIZE } from '../../../components/Thumb'
import CONST from '../../../utils/const'
import { bouncyCss } from './ComputerChoseStyles'

const ComputerChoseMobileContainer = styled(Flex)`
  width: 100%;
  padding-top: 15%;
  flex-direction: column;
`

const Title = styled('div')`
  color: white;
  text-transform: uppercase;
  font-size: 10px;
  padding-top: 40px;
  text-align: center;
`

const visibleHidden = {
  visibility: 'hidden'
}

const ComputerChoseMobile = ({ userChose, computerChose }) => {
  return (
    <ComputerChoseMobileContainer>
      <Flex justifyContent="space-around">
        <Flex flexDirection="column">
          <Thumb thumbSize={THUMB_SIZE.MEDIUM} thumbType={userChose} hasWon={false} />
          <Title>You Picked</Title>
        </Flex>
        <Flex flexDirection="column" css={bouncyCss}>
          <CSSTransition in={computerChose !== ''} classNames="bouncy" timeout={1000}>
            <Thumb
              key="computerChose"
              thumbSize={THUMB_SIZE.MEDIUM}
              thumbType={computerChose}
              hasWon={false}
            />
          </CSSTransition>
          {computerChose === '' && (
            <Thumb
              style={visibleHidden}
              thumbSize={THUMB_SIZE.MEDIUM}
              thumbType={CONST.TYPES.ROCK}
              hasWon={false}
            />
          )}
          <Title>The House Picked</Title>
        </Flex>
      </Flex>
    </ComputerChoseMobileContainer>
  )
}

export default ComputerChoseMobile
